import { getRoutesDirections } from '@/data/libraries/Routes';
import { translate } from '@/domain/utils/translate';

import MessageLayout from '@/ui/containers/MessageLayout';

/** Componente pagina NotFound
 *@component
 */
const NotFound = (): JSX.Element => {
  /** VARIABLES DE ENTORNO */
  const URL_IMAGES: string = process.env.REACT_APP_URL_IMAGES ?? '';

  /** Rutas URLs */
  const routesDirections = getRoutesDirections();

  return (
    <MessageLayout
      title={translate("home.not_found_page_title")}
      imgSrc={`${URL_IMAGES}/client/empty-list-img.png`}
      description={translate("home.not_found_page_info")}
      linkText={translate("home.home_link_info")}
      route={routesDirections.MAIN_ROUTE}
    />
  );
};

export default NotFound;
